var direction;
function mainHeaderPosition(direction){
    if (!$('.mh-navbar').hasClass('active')){
        var wS = $(window).scrollTop();
        var mH = $('.main-header__sticky-wrapper');
        var mHeight = mH.outerHeight();
        if(wS > mHeight){
            mH.addClass('is-sticky');
            if(direction == 1){
                mH.addClass('display-block');
                setTimeout(function() {
                    mH.addClass('is-active');
                }, 50);
            }
            else {
                mH.removeClass('is-active');
                setTimeout(function () {
                    mH.removeClass('display-block');
                }, 50);
            }
        }
        else if (wS < 1) {
            mH.removeClass('is-active display-block is-sticky');
        }
    }
}

function galleryTabsFilterRow(direction) {
    var wS = $(window).scrollTop();
    var tabs = $('.tabs-gallery-placeholder');
    var tabsOffset = tabs.offset().top
    var mH = $('.main-header__sticky-wrapper');
    var mHeight = mH.outerHeight();
    if (wS >= tabsOffset) {
        tabs.addClass('is-sticky');
        if (direction == 1) {
            setTimeout(function () {
                tabs.addClass('is-active');
            }, 50);
            setTimeout(function () {
                tabs.addClass('is-sharp');
            }, 1000);
        }
        else {
            tabs.removeClass('is-active is-sharp');
        }
    }
    else if (wS < (tabsOffset + mHeight)) {
        tabs.removeClass('is-active is-sticky');
    }
}

$(window).on('load', function(){
    direction = 1;
    mainHeaderPosition(direction);
    if ($('.tabs-gallery-placeholder').length) {
        galleryTabsFilterRow(direction);
    }
});
$(window).on('scroll', function () {
    var st = $(this).scrollTop();
    if (st > lastScrollTop) {
        // downscroll
        direction = 0;
        mainHeaderPosition(direction);
        if ($('.tabs-gallery-placeholder').length){
            galleryTabsFilterRow(direction);
        }
    }
    else {
        // upscroll
        direction = 1;
        mainHeaderPosition(direction);
        if ($('.tabs-gallery-placeholder').length) {
            galleryTabsFilterRow(direction);
        }
    }
    lastScrollTop = st;

});
$(document).on('click', '.mh-navbar__toggler', function(){
    $('.main-header__sticky-wrapper').removeClass('is-sticky display-block is-active');
});